import api from './index'
export function login(data) {
    return api.post('auth/login', data)
}
export function forgetPassword(data) {
    return api.post('auth/forgotpassword', data)
}
export function resetPassword(data) {
    return api.post('auth/resetpassword', data)
}
export function changePassword(data) {
    return api.post('auth/changePassword', data)
}
export function duplicate(payload) {
    return api.post('/post/duplicate', payload );
}
export function checkUniqueBatchNumber(payload) {
    return api.post('/post/checkUniqueBatchNumber', payload)
}
export function getClients(){
    return api.get('/dashboard/get-clients');
}
export function logout() {
    return api.post('auth/logout')
}
export function list(page) {
    return api.get('post/get?page='+page)
}
export function getpost(params) {
    return api.get('post/get',{params:params})
}
export function postDataAdd(data) {
    return api.post('post/store', data)
}
export function getScanningData(payload) {
    return api.post('/dashboard', payload)
}
export function getAverageVerificationTimeData(payload) {
    return api.post('/dashboard/averageVerificationTime', payload)
}
export function getCertificatesScanned(payload) {
    return api.post('/dashboard/certificatesScanned', payload)
}
export function checkUniqueSku(payload) {
    return api.post('/post/isSkuUnique', payload)
}
export function getPercentageOfAttempts(payload) {
    return api.post('/dashboard/percentage-of-attempts', payload)
}
export function getOpenIds(payload) {
    return api.get('/dashboard/open-ids/'+payload);
}
export function updateProfile(payload) {
    return api.post('/dashboard/update-profile', payload)
}
export function getImages(payload, column) {
    return api.get('/dashboard/get-images/'+payload + '/'+ column);
}
export function checkTagUniqueness(payload) {
    return api.post('/post/isTagUnique', payload);
}
export function getAreaChartData(payload) {
    return api.post('/dashboard/area', payload)
}
export function getFakeVsGenuine(payload) {
    return api.post('/dashboard/fake-vs-genuine', payload)
}

export function getUnsureResults(payload) {
    return api.post('/dashboard/unsure-results', payload)
}
export function getScansOverTime(payload) {
    return api.post('/dashboard/scans-over-time', payload)
}
export function listActivity() {
    return api.get('post/activity')
}
export function postDelete(params) {
    return api.delete('post/delete/'+params.id+'?id='+params.id,params)
}
export function getLanguagesApi(){
    return api.get('language/get')
}
export function getTableauToken(){
    return api.get('/tableau/token')
}

export default {
    users: 'users/',
    add_user: 'users/add',
}
